const s = {
  name: "Ratio3x4",
  dimensions: { width: 30, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 40" style="enable-background:new 0 0 30 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,6h-4V4h6v6h-2V6z"/>
		<path class="st0" d="M6,30v4h4v2H4v-6H6z"/>
		<path class="st0" d="M30,0v40H0V0H30z M28,2H2v36h26V2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Ratio3x4
};
